<app-loading [gameInit]="gameInit"></app-loading>
<div #container style="display: flex; align-items: center; justify-content: center;height: 100%;">
    <div class="cuagame scroll">
        <div class="level-game" [id]="'level'+ index.id" *ngFor="let index of data.maps"
             (click)="goLevel({level:index.id, currentLevel: data.currentLevel, page: data.page, topic: data.topic})">
            <img alt="" src="../../../assets/images/level-deactive.png"
                 *ngIf="index.id > (data.currentLevel > MAX_LEVEL? MAX_LEVEL : (data.currentLevel-1)) && index.id <= MAX_LEVEL_UNLOCK && gameActive !== 'unlock'">
            <img class="nhap-ma" alt="" src="../../../assets/images/level-lock.png"
                 *ngIf="index.id > (data.currentLevel > MAX_LEVEL? MAX_LEVEL : (data.currentLevel-1)) && index.id > MAX_LEVEL_UNLOCK && gameActive !== 'unlock'">
            <img alt="" src="../../../assets/images/level-deactive.png"
                 *ngIf="index.id > (data.currentLevel > MAX_LEVEL? MAX_LEVEL : (data.currentLevel-1)) && gameActive === 'unlock'">
            <img alt="" src="../../../assets/images/level-active.png"
                 *ngIf="index.id <= (data.currentLevel > MAX_LEVEL? MAX_LEVEL : (data.currentLevel-1)) && (gameActive === 'unlock' || index.id <= MAX_LEVEL_UNLOCK)">
            <img alt="" src="../../../assets/images/level-active-lock.png"
                 *ngIf="index.id <= (data.currentLevel > MAX_LEVEL? MAX_LEVEL : (data.currentLevel-1)) && gameActive !== 'unlock' && index.id > MAX_LEVEL_UNLOCK">
            <div class="number-level">
                <!--                <p *ngIf="index.id <= (data.currentLevel > 20? 20 : (data.currentLevel-1))">{{ index.id }}</p>-->
                <p *ngIf="gameActive === 'unlock' || index.id <= MAX_LEVEL_UNLOCK">{{ index.id }}</p>
            </div>
        </div>
    </div>
</div>
<app-code></app-code>

